export { matchPath as default } from 'react-router';


//////////////////
// WEBPACK FOOTER
// ../node_modules/react-router-dom/es/matchPath.js
// module id = 1196
// module chunks = 0